import ComposeInfoState from './compose-info-state'
import OfficeApiInfoState from './office-api-info-state'

export default class MailboxItemState {
  initialItemOpenSent: boolean = false
  trackingInfoSentWithoutThreadId = false
  targetMailbox: string = ''
  composeInfo: ComposeInfoState
  apiInfo: OfficeApiInfoState

  constructor() {
    this.composeInfo = new ComposeInfoState()
    this.apiInfo = new OfficeApiInfoState()
  }

  resetState() {
    this.initialItemOpenSent = false
    this.trackingInfoSentWithoutThreadId = false
    this.targetMailbox = ''
    this.composeInfo.resetState()
    this.apiInfo.resetState()
  }
}
